
import { defineComponent } from "vue";
import ToolbarLogo from "../components/toolbar-logo.vue";
export default defineComponent({
  emits: ["logoClicked"],
  components: { ToolbarLogo },
});
